export enum UserRightsActions {
  readTask = 'Read',
  addTask = 'Add',
  updateTask = 'Edit',
  deleteTask = 'Delete',
  uploadTask = 'Upload',
}
